import { SocialMediaIdentifier } from "0.Mine/3.Interfaces/social";
import { Account } from "0.Mine/3.Interfaces/socialResponse";

import { AdditionalParams, QlickupActions, useQlickupAPI } from "../APICall";

export const useHandleSocial = () => {
  const { QlickUpAPI } = useQlickupAPI();

  const connectSocial = async (businessId: number, social: SocialMediaIdentifier) => {
    try {
      const additionalParams: AdditionalParams = {
        social: SocialMediaIdentifier[social].toLowerCase(),
      };
      const response = await QlickUpAPI(
        businessId.toString(),
        "MC_connectbusiness",
        null,
        "connectsocial",
        QlickupActions.POST,
        additionalParams
      );

      console.log(response, "response from connect social");
      if (response.success) {
        const { whiteLabelLink } = response;

        // Open in popup window instead of redirecting
        const width = 600;
        const height = 700;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;

        const popup = window.open(
          whiteLabelLink,
          "socialAuthPopup",
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
        );

        // Handle popup blocked scenario
        if (!popup || popup.closed || typeof popup.closed === "undefined") {
          console.warn("Popup was blocked. Please allow popups for this website.");
          // Fallback to redirect if needed
          // window.location.href = whiteLabelLink;

          // Or show a user-friendly message
          alert("Please enable popups to authenticate with the social media platform.");
        }
      } else {
        console.error("Error connecting social media:", response.error);
      }
    } catch (error) {
      console.error("Error connecting social media:", error);
    }
  };

  const retrieveConnectedSocials = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getsocials",
        null,
        "connectsocial",
        QlickupActions.GET
      );

      if (response.success) {
        console.log(response);
        return response.accounts as Account[];
      } else {
        console.error("Error retrieving connected socials:", response.error);
      }
    } catch (error) {
      console.error("Error retrieving connected socials:", error);
    }
  };

  return { connectSocial, retrieveConnectedSocials };
};
